<template>
  <div>
    <h4 style="font-weight: 900" v-if="profile">
      Hello
      {{
        (profile.first_name || "") +
        " " +
        (profile.last_name || "") +
        (profile.first_name || profile.last_name ? " - " : "")
      }}
      {{ profile.email }}
    </h4>
    <h6 style="font-style: italic; font-weight: 100">
      you are logged as <strong>{{ prettyRole }}</strong> in
      <strong v-if="profile">{{ profile.currentOrganization.name }}</strong>
    </h6>
  </div>
</template>

<script>
import { accessToken, parseJwt } from "../../../Utils/auth";
import gql from "graphql-tag";
const PROFILE = gql`
  query profile($id: uuid!, $defaultOrganizationId: uuid!) {
    users_by_pk(id: $id) {
      id
      email
      first_name
      last_name
      role
      organization {
        id
        name
      }
    }
    organizations_by_pk(id: $defaultOrganizationId) {
      id
      name
    }
  }
`;
export default {
  name: "NavbarInvitation",
  data() {
    return {};
  },
  computed: {
    prettyRole() {
      if (this?.profile?.role) {
        return this.profile.role.replaceAll("_", " ");
      }
    },
  },
  apollo: {
    profile: {
      query: PROFILE,
      variables() {
        const parsedJWT = parseJwt(accessToken());
        const { sub } = parsedJWT;
        const defaultOrganizationId = parsedJWT['https://hasura.io/jwt/claims']?.['x-hasura-organization-id']
        return {
          id: sub,
          defaultOrganizationId,
        };
      },
      update: data => {
        return {...data.users_by_pk, currentOrganization: data.organizations_by_pk};
      }
    }
  }
};
</script>

<style>
</style>